import type { Hydratable } from '@vimcar/mvvm/hydratable'

import * as dataMapper from '@vimcar/mvvm/dataMapper'
import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import type { Nodes, ContentType, NodeTypes } from '../'
import type { LinkGroup } from '../LinkGroup'
import type { NodeLink } from '../NodeLink'

type _CustomNode = {
  id: string
  title: string
  customType: string
  text: string
  subtext: string
  allowBack: boolean
  _nextNode: Array<{ sys: { id: string } }>
  _options: Array<{ sys: { id: string } }>
  _linkGroup: { sys: { id: string } }

  contentModelType: ContentType
  nextNode: NodeTypes
  options: Array<NodeLink>
  linkGroup?: LinkGroup | null
}

// @ts-expect-error@2314
export type CustomNode = Hydratable<_CustomNode, object>

type Options = { nodes: Nodes }

const mkCustomNode = hydratable(
  ({ nodes }: Options) => {
    const customNode = mobx.observable({
      contentModelType: 'customNode',
      get nextNode() {
        // @ts-expect-error@2339
        return customNode._nextNode && nodes.get(customNode._nextNode.sys.id)
      },
      get options() {
        const optionIds =
          customNode._options && customNode._options.map((o) => o.sys.id)
        return (
          customNode._options &&
          nodes.nodeLinks
            .values()
            .filter((link) =>
              customNode._options.some((ref) => ref.sys.id === link.id),
            )
            .sort(
              (link1, link2) =>
                optionIds.indexOf(link1.id) - optionIds.indexOf(link2.id),
            )
        )
      },
      get linkGroup() {
        return customNode._linkGroup && nodes.get(customNode._linkGroup.sys.id)
      },
    } as _CustomNode)
    return customNode
  },
  'CustomNode',
  {
    fields: dataMapper.lift({
      nextNode: '_nextNode',
      options: '_options',
      linkGroup: '_linkGroup',
    }),
    sys: dataMapper.lift({
      id: true,
    }),
  },
)

export default mkCustomNode
